import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export default gql`
query policiesLookup(
	$skip: Int
	$take: Int
	$where: PolicyLookupFilterInput
	$order: [PolicyLookupSortInput!]
	$activeOnly: Boolean
	$includeWaitPolicies: Boolean
) {
	policiesLookup(
	activeOnly: $activeOnly
	includeWaitPolicies: $includeWaitPolicies
	skip: $skip
	take: $take
	where: $where
	order: $order
)    {
      pageInfo{
        hasNextPage,
        hasPreviousPage
      },

        items {
        	active,
        	wait,
        	brancheGroup { omschrijving }
        	brancheSpec { omschrijving }
        	company { naam }
            customer { id, naam, postcode, plaats, emailadres },
            broker { id, naam}
            policy { id, kenteken, nr, relnr, swPakket
            }
        }
    }
}`;
